import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import '../styles/landing.css';
import WhatsAppButton from '../components/common/WhatsAppButton';

const industries = {
  hardware: { name: 'Hardware Stores', query: 'hardware business' },
  wholesale: { name: 'Wholesalers & Distributors', query: 'wholesale business' },
  retail: { name: 'Retail Shops & Supermarkets', query: 'retail shop' },
  minimart: { name: 'Minimarts & Convenience Stores', query: 'minimart' },
  electronics: { name: 'Electronics Shops', query: 'electronics shop' },
  'spare-parts': { name: 'Auto Spare Parts', query: 'spare parts business' },
  agrovet: { name: 'Agrovets', query: 'agrovet' },
};

const IndustryTemplate = () => {
  const { industryId } = useParams();
  const industry = industries[industryId] || { name: 'Growing Businesses', query: 'business' };

  useEffect(() => {
    document.title = `Harvyq for ${industry.name} | POS & Inventory Kenya`;
    window.scrollTo(0, 0);
  }, [industry]);

  const whatsappMessage = `Hello Harvyq, I run a ${industry.name.toLowerCase()} and I'd like to see how Harvyq can help me manage stock and sales.`;

  return (
    <div className="landing industry-page">
      <nav className="navbar sticky">
        <Link to="/" className="logo">
          <span className="logo-icon">🛍️</span>
          <span className="logo-text">Harvyq</span>
        </Link>
        <div className="nav-links">
          <Link to="/" className="btn-secondary">Back to Home</Link>
          <Link to="/register" className="btn-primary">Start Free Trial</Link>
        </div>
      </nav>

      <section className="hero">
        <div className="hero-content" style={{ textAlign: 'center', margin: '0 auto', maxWidth: '800px', padding: '100px 20px' }}>
          <p className="hero-eyebrow">Built for {industry.name}</p>
          <h1 style={{ fontSize: '3rem', marginBottom: '20px' }}>Run Your {industry.name} Better with Harvyq</h1>
          <p style={{ fontSize: '1.2rem', color: 'var(--text-secondary)', marginBottom: '40px' }}>
            Manage sales, stock, customers, suppliers, and business performance without juggling notebooks and spreadsheets.
          </p>
          <div className="hero-buttons" style={{ justifyContent: 'center' }}>
            <Link to="/register" className="btn-primary btn-large">Start Free for 14 Days</Link>
            <a href={`https://wa.me/254726642205?text=${encodeURIComponent(whatsappMessage)}`} className="btn-secondary btn-large" target="_blank" rel="noopener noreferrer">
              Talk to Us on WhatsApp
            </a>
          </div>
        </div>
      </section>

      <WhatsAppButton message={whatsappMessage} />
    </div>
  );
};

export default IndustryTemplate;
